import type { ValueEvent } from '@adornis/base/utilTypes.js';
import type { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { FormController } from '@adornis/forms/x-form-controller.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import '@chancenwerk/components/chancen-component-choose-digital-courses.js';
import { ChancenDialogTimeMatrix } from '@chancenwerk/components/dialogs/chancen-dialog-time-matrix.js';
import type { CourseDigital } from '@chancenwerk/db/courses/CourseDigital.js';
import type { Student } from '@chancenwerk/master-data-management/users/entities/Student.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import ImageClientsSupport from './../assets/Classroom-med-min.png';
import { AnmeldungPageRegistrationBase } from './anmeldung-component-formular-base.js';

/**
 * @customElement anmeldung-component-formular-digital-courses
 */
@customElement('anmeldung-component-formular-digital-courses')
export class AnmeldungPageRegistrationDigitalCourses extends AnmeldungPageRegistrationBase {
  @property({ attribute: false }) form!: FormController<Student>;
  @property({ attribute: false }) translation!: TranslationController<any>;
  @property({ attribute: false }) student!: RXController<Student>;
  @property({ attribute: false }) digitalCoursesChoosen: CourseDigital[] = [];
  @property({ attribute: false }) digitalCourses!: RXController<CourseDigital[]>;

  override render() {
    return html`
      <cr-flex class="section-container" space="xl">
        <cr-image disabled .value=${ImageClientsSupport} mode="contain"> </cr-image>

        <cr-flex class="sc-content">
          <cr-flex space="lg">
            <cr-flex space="md">
              <cr-text ${css({ textAlign: 'justify' })} bold>
                Du hast einen Wunschtermin für deinen Intensivkurs vor Ort gefunden?
              </cr-text>
              <cr-flex space="sm" horizontal crossaxis-center>
                <cr-icon ${css({ fontSize: '1.8rem' })}>arrow_forward</cr-icon>
                <cr-text ${css({ textAlign: 'justify' })}>
                  Du kannst zusätzlich noch einen digitalen Intensivkurs wählen.
                </cr-text>
              </cr-flex>
            </cr-flex>
            <cr-flex space="md">
              <cr-text ${css({ textAlign: 'justify' })} bold>
                Du hast keinen Wunschtermin für deinen Intensivkurs vor Ort gefunden?
              </cr-text>
              <cr-flex space="sm" horizontal crossaxis-center>
                <cr-icon ${css({ fontSize: '1.8rem' })}>arrow_forward</cr-icon>
                <cr-text ${css({ textAlign: 'justify' })}> Wähle hier deinen digitalen Intensivkurs. </cr-text>
              </cr-flex>
            </cr-flex>

            <cr-text>
              Aktuell werden diese digitalen Intensivkurse zu deinem Wunschfach zu folgenden Uhrzeiten bereits
              angeboten. Wähle hier gerne ein bis zwei digitale Intensivkurse aus, an denen du teilnehmen möchtest:
            </cr-text>

            <chancen-component-choose-digital-courses
              .student=${this.student.value}
              .digitalCourses=${this.digitalCourses.value}
              .digitalCoursesChoosen=${this.digitalCoursesChoosen}
              @value-picked=${(e: ValueEvent<Student>) => this.student.next(this.student.value)}
            >
            </chancen-component-choose-digital-courses>

            <cr-flex horizontal end crossaxis-center space="sm">
              <cr-button
                mode="outline"
                @click=${async () => {
                  const student = await ChancenDialogTimeMatrix.showPopup<Student>({
                    props: { student: this.student.value },
                  });
                  this.student.next(student);
                  this.requestUpdate();
                }}
              >
                Keinen digitalen Intensivkurs gefunden?
              </cr-button>
              <cr-button
                @click=${async () => {
                  this.form.validate().catch(console.error);
                }}
              >
                ${this.translation.translate('next')}
              </cr-button>
            </cr-flex>
          </cr-flex>
        </cr-flex>
      </cr-flex>
    `;
  }
}
